module.exports = __webpack_public_path__ + "static/media/georges-logo.1fbd231d.png";